import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { QueryParamsFromParentApp } from './types';
import { getInitialState } from './util/getInitialState';
import { recalcuatedEnergyVals } from '../RoofDataSlice/roofDataSlice';

const initialState: { data: QueryParamsFromParentApp } = {
	data: getInitialState()
};

export const QueryParamsFromParentAppSlice = createSlice({
	name: 'queryParamsProvider',
	initialState,
	reducers: {
		setQueryParamState: (state, action: PayloadAction<QueryParamsFromParentApp>) => {
			// displayMode is read from the URL at startup and then only changed by setDisplayMode
			// (the parent's DISPLAY_MODE_CHANGED). Keep it, so a page load that finishes after the
			// parent switched theme doesn't flip it back to the URL value.
			state.data = { ...action.payload, displayMode: state.data.displayMode };
		},
		setEnergyDerate: (state, action: PayloadAction<{ energyDerate: number, }>) => {
			state.data.derateRateBeforeUserSwitchToNonDefaultModes = state.data.energyDerateRate;
			state.data.energyDerateRate = action.payload.energyDerate;
		},
		// one-shot: once the design is on the parent's panel, stop matching against it so a later
		// manual panel change is not treated as a mismatch and reverted
		clearAddNewPanel: (state) => {
			state.data.addNewPanel = false;
		},
		setEneryDerateToQueryParamState: (state) => {
			state.data.energyDerateRate = state.data.derateRateBeforeUserSwitchToNonDefaultModes;
		},
		setDisplayMode: (state, action: PayloadAction<DisplayMode>) => {
			state.data.displayMode = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(recalcuatedEnergyVals.fulfilled, (state, action) => {
				if (state.data.electricUnitPrice !== action.payload.energyState.electricUnitPrice)
					state.data.electricUnitPrice = action.payload.energyState.electricUnitPrice;
			});
	}
});

export const { setQueryParamState, setEnergyDerate, setEneryDerateToQueryParamState, clearAddNewPanel, setDisplayMode } = QueryParamsFromParentAppSlice.actions;

export default QueryParamsFromParentAppSlice.reducer;